import {React, useEffect} from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Footer from './components/header+footer/Footer';
import Landing from './pages/Landing';
import MainSiteContainer from './pages/MainSiteContainer';
import './assets/css/main.css';
import {FeedbackProvider} from './contexts/eventFeedback';
import NotFoundFolder from './pages/404/Index';
import Verify from './pages/Verification/Verify';
import { SessionProvider } from './contexts/session';

function App() {

  return (
    <Router>
      <FeedbackProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/verify/:token/*" element={<Verify />} />
          <Route path="/client/*" element={
            <main>
              <SessionProvider>
                <MainSiteContainer />
              </SessionProvider>
            </main>
          } />
          <Route path="/*" element={<NotFoundFolder />} />
        </Routes>
        <Footer />
      </FeedbackProvider>
    </Router>
  );
}

export default App;
